import Vue from 'vue'

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import 'flex.box/src/flexbox.css'

Vue.use(ElementUI, { locale })

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
Vue.use(VueMoment, {
    moment,
})

Vue.config.productionTip = false
axios.defaults.baseURL = `/api`

new Vue({
  el: '#app',
  components: {
    QuoteForm    : () => import(/* webpackChunkName: "bookingForm" */ './QuoteForm.vue'),
    QuoteFormNew : () => import('./QuoteFormNew.vue')
  }
})




